'use strict'
import moment from 'moment'
export function relativeTime(time) {
  return moment(time).format('YYYY-MM-DD HH:mm:ss')
}
export function relativeTimeH(time) {
  return moment(time).format('YYYY-MM-DD HH')
}

